import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import ProtocolService from '../Python/APIs/ProtocolService'
import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'

export function useProtocolGet(path: string, enabled: boolean = true) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<any, AxiosResponse>(
    ['Protocol', path],
    () => ProtocolService.get(whoAmI, path),
    {
      enabled: !!whoAmI && enabled,
      onError: (err) => setError(err),
    },
  )
}
